import { PropsWithChildren, StrictMode } from "react"
import { Header } from "common/components/Header"
import { Footer } from "common/components/Footer"
import { PromosContext } from "modules/promos/contexts/PromosContext"
import { Slot } from "modules/promos/components/Slot/Slot"
import { useTranslations } from "modules/i18n/hooks/useTranslations"
import { usePageProps } from "common/hooks/data/usePageProps"
import { ViewPageProps } from "./index.page"

export const Content = ({ children }: PropsWithChildren<{}>) => {
  const { meta } = usePageProps<ViewPageProps>()
  const t = useTranslations("layout")
  const topStoriesTranslation = t("top_stories_aria_label")
  const hasTranslationForTopStories = topStoriesTranslation !== "top_stories_aria_label"

  return (
    <main id="main-content" tabIndex={-1} className="tc-container container mx-auto my-5">
      {meta?.title && <h1 className="sr-only">{meta.title}</h1>}
      {hasTranslationForTopStories && <h2 className="sr-only">{topStoriesTranslation}</h2>}

      {children}
    </main>
  )
}

export const Layout = ({ children }: PropsWithChildren<{}>) => {
  const currentYear = new Date().getFullYear()

  return (
    <StrictMode>
      <PromosContext>
        <div className="flex h-screen flex-col justify-between">
          <Header />

          <Slot name="banner" />

          <Content>{children}</Content>
          <Footer year={currentYear} />
        </div>
        <Slot name="modal" />
      </PromosContext>
    </StrictMode>
  )
}
